export default {
// 获取字典类型数据
  cancelApply: {
    url: '/mp/order/jdPayAgreement/cancel/apply',
    method: 'POST'
  }
};
